module.exports = __webpack_public_path__ + "img/img_communaute1.c9ca2d2b.jpg";